import * as React from 'react';
import { Icon } from '../../primitives/icon/icon';
/* tslint:disable */
var icon = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n<g>\n\t <path d=\"M18 8v1H3l4.25 4-.75.75L1 8.5l5.5-5.25.75.75L3 8h15z\"/>\n</g>\n</svg>";
export var NavArrowIcon = function () { return React.createElement(Icon, { icon: icon }); };
//# sourceMappingURL=nav-arrow-icon.js.map